var exports = {
  "aP": "VoiceSceneChatBox.module__box___Y0tGMn",
  "hF": "VoiceSceneChatBox.module__input___Y0tGMn",
  "NN": "VoiceSceneChatBox.module__slowmode___Y0tGMn",
  "x6": "VoiceSceneChatBox.module__button___Y0tGMn",
  "Kk": "VoiceSceneChatBox.module__icon___Y0tGMn",
};

module.exports = exports;
